import { get } from 'lodash';

import { addPost } from '../../actions/add-post';
import { discardPostDraft } from '../../actions/discard-post-draft';
import { discardPostSettings } from '../../actions/discard-post-settings';
import { revertPostToDraft } from '../../actions/revert-post-to-draft';
import { refreshPosts } from '../../actions/refresh-posts';
import { submitPostSettings } from '../../actions/submit-post-settings';
import { triggerPostDraftSave } from '../../actions/trigger-post-draft-save';
import { triggerPostPublish } from '../../actions/trigger-post-publish';
import goBack from '../../actions/go-back';
import { goBack as rrrGoBack } from 'react-router-redux';
import {
  MODAL_TYPE_DISCARD_POST,
  MODAL_TYPE_DISCARD_POST_DRAFT,
  MODAL_TYPE_DISCARD_POST_SETTINGS,
  MODAL_TYPE_REVERT_TO_DRAFT,
  MODAL_POST_FORM_ACTIONS,
  MODAL_TYPE_POST_SETTINGS,
  MODAL_TYPE_POST_EDITOR,
  MODAL_TYPE_POST_FORM_EDIT_IN_PROGRESS,
  PUB_SUB_CHANNEL_MEMBER_DRAFTS,
  isOneAppSearchParam,
} from '@wix/communities-blog-client-common';

import { getCurrentLocation, getPreviousLocation } from '../../selectors/location-history-selectors';
import { getPostEditorInitialPost, getIsEditingDraft, getIsEditingPost } from '../../selectors/post-editor-selectors';
import { isInCreatePostPage, isInPostPage } from '../../services/detect-route';
import { push, replace } from '../../services/router-utils';
import oneAppNavigation from '../../services/navigation-provider/blog-in-one-app';

const postEditorModalResolver = (post) => (dispatch, getState) => {
  const location = getCurrentLocation(getState());
  const navigate = isInPostPage(location) || isInCreatePostPage(location) ? replace : push;

  if (post.slug) {
    dispatch(addPost(post));
    dispatch(navigate(`/${post.slug}`));
  } else {
    dispatch(goBack('/'));
  }
};

const postEditorModalResolverInOneApp = (post) => (dispatch, getState) => {
  const initialPost = getPostEditorInitialPost(getState());
  const isCreatingPost = !initialPost._id;
  const isEditingDraft = getIsEditingDraft(getState());
  const isEditingPost = getIsEditingPost(getState());

  const publishToDraftsMeta = { publish: PUB_SUB_CHANNEL_MEMBER_DRAFTS };
  const refreshDrafts = () => dispatch(refreshPosts(undefined, publishToDraftsMeta));
  const { slug } = post;

  if (post === true) {
    // X button
    if (isEditingDraft) {
      dispatch(rrrGoBack());
      return oneAppNavigation.navigateToDrafts();
    } else if (isCreatingPost || isEditingPost) {
      isCreatingPost && refreshDrafts();
      return dispatch(rrrGoBack());
    }
  }

  dispatch(addPost(post));
  if (isCreatingPost || isEditingDraft) {
    isEditingDraft && refreshDrafts();
    dispatch(rrrGoBack());
    // Timeout needed for goBack() to work
    slug && setTimeout(() => dispatch(push(`/${slug}`)), 100);
  } else if (isEditingPost) {
    dispatch(rrrGoBack());
  }
};

export default {
  [MODAL_TYPE_DISCARD_POST]: () => replace('/'),

  [MODAL_TYPE_DISCARD_POST_DRAFT]: discardPostDraft,

  [MODAL_TYPE_DISCARD_POST_SETTINGS]: discardPostSettings,

  [MODAL_TYPE_REVERT_TO_DRAFT]: revertPostToDraft,

  [MODAL_POST_FORM_ACTIONS]: (actionType) => (dispatch) => {
    switch (actionType) {
      case 'save':
        return dispatch(triggerPostDraftSave());
      case 'publish':
        return dispatch(triggerPostPublish());
      default:
        break;
    }
  },

  [MODAL_TYPE_POST_SETTINGS]: submitPostSettings,

  [MODAL_TYPE_POST_EDITOR]: (post) => (dispatch, getState) => {
    const resolver = isOneAppSearchParam(getState()) ? postEditorModalResolverInOneApp : postEditorModalResolver;
    dispatch(resolver(post));
  },

  [MODAL_TYPE_POST_FORM_EDIT_IN_PROGRESS]: () => (dispatch, getState) => {
    const location = get(getPreviousLocation(getState()), 'pathname', '/');
    dispatch(replace(location));
  },
};
